/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import {
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
  Box,
  Button,
  Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useLogin } from '../hooks/useLogin';
import { useAppSelector } from '../../../store/hooks';
import { groutColors } from '../../Visualizer/Tile/SelectGroutColors/SelectGroutColors';
import { tilePattern } from '../../Visualizer/RoomScene/room.data';
import { ReactComponent as AnalyticsIcon } from '../../../assets/images/Google-Analytics.svg';
const today = new Date();

// this week
const dayOfWeek = today.getUTCDay();
const startOfWeek = new Date(
  today.getUTCFullYear(),
  today.getUTCMonth(),
  today.getUTCDate() - dayOfWeek + 1,
);
const thisWeekStartDate = startOfWeek.toISOString().split('T')[0];

// this month
const startOfMonth = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
const thisMonthStartDate = startOfMonth.toISOString().split('T')[0];

// last month
const lastMonth = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1));
const lastMonthStartDate = lastMonth.toISOString().split('T')[0];

// last month end date
const lastMonth1 = new Date(today.getFullYear(), today.getMonth() - 1, 1);
const endDate1 = new Date(lastMonth1.getFullYear(), lastMonth1.getMonth() + 1, 0);
const year = endDate1.getFullYear();
const month = String(endDate1.getMonth() + 1).padStart(2, '0');
const day = String(endDate1.getDate()).padStart(2, '0');
const lastMonthEndDate = `${year}-${month}-${day}`;

// this year
const startOfYear = new Date(Date.UTC(today.getUTCFullYear(), 0, 1));
const thisYearStartDate = startOfYear.toISOString().split('T')[0];

// last year
const lastYear = new Date(Date.UTC(today.getUTCFullYear() - 1, 0, 1));
const lastYearStartDate = lastYear.toISOString().split('T')[0];

// last year end date
const lastYearEnd = new Date(today.getFullYear() - 1, 11, 31);
const year1 = lastYearEnd.getFullYear();
const month1 = String(lastYearEnd.getMonth() + 1).padStart(2, '0');
const day1 = String(lastYearEnd.getDate()).padStart(2, '0');
const lastYearEndDate = `${year1}-${month1}-${day1}`;

const dateRange = [
  { label: 'This Week', startDate: thisWeekStartDate, endDate: 'today' },
  { label: 'This Month', startDate: thisMonthStartDate, endDate: 'today' },
  { label: 'Last Month', startDate: lastMonthStartDate, endDate: lastMonthEndDate },
  { label: 'This Year', startDate: thisYearStartDate, endDate: 'today' },
  { label: 'Last Year', startDate: lastYearStartDate, endDate: lastYearEndDate },
];

const AdminControl = () => {
  const { getAnalyticsReport } = useLogin();
  const [date, setDate] = useState(dateRange[0]);

  const handleDate = (e) => {
    const { value } = e.target;
    setDate(value);
  };

  useEffect(() => {
    getAnalyticsReport({
      startDate: date?.startDate,
      endDate: date?.endDate,
    });
  }, [getAnalyticsReport, date]);

  const { report } = useAppSelector((state) => state.user);
  const { report1, report2 } = report || {};

  // USERS

  const report2Data = {
    guestUsers: report2?.rows?.[0]?.metricValues?.[1]?.value || 0,
    registeredUsers: report2?.rows?.[1]?.metricValues?.[1]?.value || 0,
  };

  // COLORS

  const report1Colordata = (color) => {
    return report1?.rows?.filter((val) => {
      return val?.dimensionValues?.[0]?.value === color.backgroundColor;
    });
  };

  const colorUsage = groutColors?.reduce((previous, current) => {
    const colorValue = Number(report1Colordata(current)?.[0]?.metricValues?.[0]?.value);
    if (colorValue) {
      previous.push({
        ...current,
        number: colorValue,
      });
    } else {
      previous.push({ ...current, number: 0 });
    }
    return previous;
  }, []);

  const totalSum = colorUsage.reduce((sum, color) => sum + color.number, 0);

  colorUsage.sort((a, b) => b.number - a.number);
  colorUsage.forEach((color) => {
    const p = ((color.number / totalSum) * 100)?.toFixed(2);
    color.percentage = Number(p) || 0;
  });

  // PATTERNS

  const report1Patterndata = (pattern) => {
    return report1?.rows?.filter((val) => {
      return val?.dimensionValues?.[1]?.value === pattern.installation;
    });
  };

  const patternUsage = tilePattern?.reduce((previous, current) => {
    const patternValue = Number(report1Patterndata(current)?.[0]?.metricValues?.[0]?.value);
    if (patternValue) {
      previous.push({
        ...current,
        number: patternValue,
      });
    } else {
      previous.push({ ...current, number: 0 });
    }
    return previous;
  }, []);

  patternUsage.sort((a, b) => b.number - a.number);
  patternUsage.forEach((pattern) => {
    const p = ((pattern.number / totalSum) * 100).toFixed(2);
    pattern.percentage = Number(p) || 0;
  });

  const [showMore, setShowMore] = useState(false);
  const minimumColors = showMore ? 40 : 3;
  return (
    <>
      <Paper className="AnalyticsButton">
        <Button
          className="LinkTypeButton"
          color="primary"
          onClick={() =>
            window.open(
              'https://analytics.google.com/analytics/web/?authuser=3#/p395190195/reports/intelligenthome',
              '_blank',
              'noopener',
            )
          }
        >
          <AnalyticsIcon /> View Google Analytics
        </Button>
      </Paper>
      <Paper className="AnalyticsBox">
        <Box className="CommonFormControl">
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={date}
            onChange={handleDate}
            //   renderValue={(v) => v.label}
          >
            {dateRange.map((item) => (
              <MenuItem key={item.label} value={item}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box className="UsageSummaryBox UsageCommonBox">
          <Table className="AnalyticTable">
            <TableHead>
              <th>Usage Summary</th>
              <th className="Numbers">Number</th>
            </TableHead>
            <TableBody>
              <TableRow>
                <td>
                  <Typography variant="h6">Guest Users</Typography>
                </td>
                <td className="Numbers">{report2Data?.guestUsers}</td>
              </TableRow>
              <TableRow>
                <td>
                  <Typography variant="h6">Registered Users</Typography>
                </td>
                <td className="Numbers">{report2Data?.registeredUsers}</td>
              </TableRow>
              <TableRow>
                <td>
                  <Typography variant="h6">Total Hits</Typography>
                </td>
                <td className="Numbers">
                  {Number(report2Data?.guestUsers) + Number(report2Data?.registeredUsers)}
                </td>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
        <Box className="UsageSummaryBox UsageCommonBox">
          <Table className="AnalyticTable">
            <TableHead>
              <th>
                Grout Color Usage
                <Tooltip
                  enterTouchDelay={0}
                  placement="top"
                  title="Usage figures based off of saved scenes only"
                >
                  <InfoIcon className="InfoIcon" />
                </Tooltip>
              </th>
              <th className="Numbers">Number</th>
              <th className="Numbers">% of Total</th>
            </TableHead>
            <TableBody>
              {colorUsage?.slice(0, minimumColors)?.map((v, i) => (
                <TableRow key={v?.id}>
                  <td>
                    <Box className="AnalyticsGroutColor">
                      <Typography variant="body2" className="SerialNumber">
                        {i + 1}
                      </Typography>
                      <Box
                        className="AnalyticsGroutColorBox"
                        style={{
                          backgroundColor: `${v.backgroundColor}`,
                        }}
                      ></Box>
                      <Box className="AnalyticsGroutColorName">
                        <Typography variant="body2">{v.id}</Typography>
                        <Typography variant="h6">{v.name}</Typography>
                      </Box>
                    </Box>
                  </td>
                  <td className="Numbers">{v.number}</td>
                  <td className="Numbers">{v.percentage}%</td>
                </TableRow>
              ))}
              <Button
                style={{ fontWeight: 'normal' }}
                color="primary"
                className="LinkTypeButton"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? 'View Less' : 'View All'}
              </Button>
            </TableBody>
          </Table>
        </Box>
        <Box className="UsageSummaryBox UsageCommonBox" style={{ marginBottom: 5 }}>
          <Table className="AnalyticTable">
            <TableHead>
              <th>
                Tile Pattern Usage
                <Tooltip
                  enterTouchDelay={0}
                  placement="top"
                  title="Tile pattern usage calculations based off of patterns applied only to saved scenes"
                >
                  <InfoIcon className="InfoIcon" />
                </Tooltip>
              </th>
              <th className="Numbers">Number</th>
              <th className="Numbers">% of Total</th>
            </TableHead>
            <TableBody>
              {patternUsage?.map((p, i) => (
                <TableRow key={p?.installation}>
                  <td>
                    <Box className="AnalyticsTilePattern">
                      <Typography variant="body2" className="SerialNumber">
                        {i + 1}
                      </Typography>
                      <Box
                        className="AnalyticsTilePatternBox"
                        style={{
                          backgroundImage: `url(
          ${p.thumb}
        )`,
                        }}
                      ></Box>

                      <Box className="AnalyticsTilePatternName">
                        <Typography variant="h6">{p?.name}</Typography>
                      </Box>
                    </Box>
                  </td>
                  <td className="Numbers">{p.number}</td>
                  <td className="Numbers">{p.percentage}%</td>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Paper>
    </>
  );
};

export default AdminControl;
